import React, { useState } from "react";
import { ChevronRight, Delete, Pen } from 'lucide-react';
import { Link, useLocation } from "react-router-dom";
import Taxes from "./partials/taxes";
import Units from "./partials/units";
import RawCategories from "./partials/categories";
import FinalCategories from "../categories/FinalCategory";

const AccoutingSetup = () => {
    const location = useLocation();
   

    return (
        <div className="row">
            <div className="col-md-12">
                {location.pathname == '/setup/taxes' && (
                    <Taxes/>
                )}
                {location.pathname == '/setup/units' && (
                    <Units/>
                )}
                {location.pathname == '/setup/categories' && (
                    <RawCategories/>
                )}
                {location.pathname == '/categories' && (
                    <FinalCategories/>
                )}
            </div>
            
        </div>

    );
}

export default AccoutingSetup;